/* import roof from "../../../Assets/Images/questions/questionEight/roof.svg";
import wall from "../../../Assets/Images/questions/questionEight/wall.svg";
import unknown from "../../../Assets/Images/questions/questionEight/unknown.svg"; */
export const flueData = [
  {
    title: "Roof",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642172585/AquaHeat/Quote%20Icons/question%208/roof_r2yg6f.svg",
  },
  {
    title: "Wall",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642172585/AquaHeat/Quote%20Icons/question%208/wall_xejxck.svg",
  },
  {
    title: "Unknown",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642172585/AquaHeat/Quote%20Icons/question%208/unknown_zzkhfl.svg",
  },
];
